import {Preferences} from "@capacitor/preferences";

const getWorkerId = async () => {
    const workerId = await Preferences.get({'key': 'worker_id'});

    return workerId.value;
}

const getWorkerNumber = async () => {
    const workerNumber = await Preferences.get({'key': 'employee_number'});

    return workerNumber.value;
}

const isSteamWorker = async () => {
    const isSteamWorker = await Preferences.get({'key': 'is_steam_worker'});

    return isSteamWorker.value === '1';
}

const isWorkerIdentityVerified = async () => {
    const isIdentityVerified = await Preferences.get({'key': 'is_worker_identity_verified'});

    return isIdentityVerified.value === '1';
}

const hasWorkerAccessToAvailabilities = async () => {
    const hasAccessToAvailabilities = await Preferences.get({'key': 'has_access_to_availabilities'});

    return hasAccessToAvailabilities.value === '1';
}

const isEnableAddingInternalReports = async () => {
    const isEnabled = await Preferences.get({'key': 'enable_adding_internal_reports'});

    return isEnabled.value === '1';
}

const getHoursForAvailabilityEdit = async (): Promise<number | null> => {
    const hoursForAvailabilityEdit = await Preferences.get({'key': 'hours_for_availability_edit'});

    return hoursForAvailabilityEdit.value ? parseInt(hoursForAvailabilityEdit.value) : null;
};

export {
    getWorkerId,
    getWorkerNumber,
    isSteamWorker,
    isWorkerIdentityVerified,
    isEnableAddingInternalReports,
    hasWorkerAccessToAvailabilities,
    getHoursForAvailabilityEdit,
};